import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import PageLoader from "components/PageLoader";

const LazyOfficeLocation = lazy(() => import("pages/OfficeLocation"));
const LazyOfficeLocationDetail = lazy(() => import("pages/OfficeLocationDetail"));
const LazyOfficeLocationForm = lazy(() => import("pages/OfficeLocationForm"));

const OfficeLocationRoute = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<LazyOfficeLocation />} />
        <Route path="/new" element={<LazyOfficeLocationForm />} />
        <Route path="/:id" element={<LazyOfficeLocationDetail />} />
        <Route path="/:id/edit" element={<LazyOfficeLocationForm />} />
      </Routes>
    </Suspense>
  );
};

export default OfficeLocationRoute;
